import {Injectable} from "@angular/core";
import {SearchResponse} from "../../../objects/responses/searchResponse";
import {BaseSearchRequest} from "../../../objects/requests/baseSearchRequest";
import {ProductSearchRequest} from "../../../objects/requests/productSearchRequest";
import {ProductService} from "../../../services/productService";
import {Product} from "../../../objects/products/product";
import {BaseResponse} from "../../../objects/common/baseResponse";
import {RequestType} from "../../../objects/products/requestType";
/**
 * Created by alex.y on 9/11/2017.
 */

@Injectable()
export class ProductManagementResolver {

    constructor(private productService: ProductService) {
    }

    public resolve(): Promise<SearchResponse<Product>> {

        return this.productService.search(new ProductSearchRequest({
            Skip: 0,
            Top: 12,
            Query: '',
            Source: null,
            RequestType: RequestType.Search
        })).then((result:BaseResponse<SearchResponse<Product>>) => {
            return result.Data;
        }).catch((err: any) => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/productManagement/productManagement.resolver.ts